import { useNavigation } from "@react-navigation/native";
import { createContext, useContext, useState } from "react";
import { api } from "../api/api";
import UserContext from "./user";

interface RegisterDriverContextData {
  drivers: any;
  setDrivers: any;
  driversSelects: any;
  setDriversSelects: any;
  getDrivers(): Promise<void>;
  registerDrivers(data: any): Promise<void>;
  updateDataDriver(data: any, id: number): Promise<void>;
}

const RegisterDriverContext = createContext({} as RegisterDriverContextData);

export function RegisterDriverProvider({ children }) {
  const navigation = useNavigation();
  const { user } = useContext(UserContext);
  const [drivers, setDrivers] = useState([]);
  const [driversSelects, setDriversSelects] = useState([]);

  async function getDrivers() {
    await api.get('/users').then((response) => {
        let drivers = [];
        response.data.users.map((item: any) => {
            drivers.push({label:item.name, value: item.id});
        });
        console.log(drivers);
        setDrivers(response.data.users);
        setDriversSelects(drivers);
    })
    .catch((err) => {
        console.log('getDrivers', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function registerDrivers(data: any) {
    await api.post('/users', data).then(async (response) => {
        console.log(response.data);
        await getDrivers();
    })
    .catch((err) => {
        console.log('registerDrivers', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function updateDataDriver(data: any, id: number) {
    await api.put(`/users/${id}`, data).then(async (response) => {
        console.log(response.data);
        await getDrivers();
    })
    .catch((err) => {
        console.log('registerDrivers', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  return (
    <RegisterDriverContext.Provider value={{ drivers,
      driversSelects,
      setDriversSelects,
      setDrivers,
      getDrivers,
      registerDrivers,
      updateDataDriver
    }}>
      {children}
    </RegisterDriverContext.Provider>
  );
}

export default RegisterDriverContext;
